import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["toggle", "content"]

  connect() {
    // Initialize all sections as closed
    this.contentTargets.forEach(content => {
      content.style.maxHeight = "0"
      content.classList.remove("active")
    })
  }

  toggle(event) {
    const toggleButton = event.currentTarget
    const targetId = toggleButton.dataset.target
    const content = document.getElementById(targetId)
    const arrow = toggleButton.querySelector('.toggle-arrow')

    if (content.classList.contains('active')) {
      // Close the section
      content.style.maxHeight = "0"
      content.classList.remove('active')
      toggleButton.classList.remove('active')
      if (arrow) arrow.style.transform = 'rotate(0deg)'
    } else {
      // Open the section
      content.style.maxHeight = content.scrollHeight + "px"
      content.classList.add('active')
      toggleButton.classList.add('active')
      if (arrow) arrow.style.transform = 'rotate(180deg)'
    }
  }
}